import { useEffect } from 'react'

/**
 * Check if an element is visible in the Y axis.
 * Taken from https://stackoverflow.com/a/21627295/837649
 * @param {Element} el
 * @returns {boolean}
 */
export var visibleY = function(elR) {
  var rect = elR.getBoundingClientRect(),
    top = rect.top,
    height = rect.height,
    el = elR.parentNode
  // Check if bottom of the element is off the page
  if (rect.bottom < 0) return false
  // Check its within the document viewport
  if (top > document.documentElement.clientHeight) return false
  do {
    rect = el.getBoundingClientRect()
    // eslint-disable-next-line no-mixed-operators
    if (top <= rect.bottom === false) return false
    // Check if the element is out of view due to a container scrolling
    if (top + height <= rect.top) return false
    el = el.parentNode
  } while (el !== document.body)
  return true
}

/**
 * Creates a `useEffect()` hook that fires a function when the user scrolls.
 * Can use this to do things like setting things with fixed positions on
 * scroll
 */
export const useOnScrollHook = function(positionFunc) {
  var ticking
  var onScroll = () => {
    if (!ticking) {
      window.requestAnimationFrame(function() {
        positionFunc()
        ticking = false
      })
      ticking = true
    }
  }

  return useEffect(function() {
    window.addEventListener('scroll', onScroll)
    return () => window.removeEventListener('scroll', onScroll)
  })
}

/**
 * Copies a string to the clipboard.
 * Taken from https://techoverflow.net/2018/03/30/copying-strings-to-the-clipboard-using-pure-javascript/
 * @param {string} str
 */
export const copyStringToClipboard = function(str) {
  // Create new element
  var el = document.createElement('textarea')
  // Set value (string to be copied)
  el.value = str
  // Set non-editable to avoid focus and move outside of view
  el.setAttribute('readonly', '')
  el.style = { position: 'absolute', left: '-9999px' }
  document.body.appendChild(el)
  // Select text inside element
  el.select()
  // Copy text to clipboard
  document.execCommand('copy')
  // Remove temporary element
  document.body.removeChild(el)
}

export const loadImage = url => {
  return new Promise((resolve, reject) => {
    var img = new Image(1, 1)
    //img.addEventListener('load', () => resolve(img))
    //img.addEventListener('error', reject)
    img.onload = resolve
    img.onerror = reject
    img.src = url
  })
}
